import React from "react";
import { BloxButton } from "styled_components/Common/BloxButton";
import { IconButton } from "styled_components/Common/IconButton";
import styled from "styled-components";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const CloseIcon = `${CDN_URL}common/X-close-primary.svg`;

const JoyRideToolTipStyle = styled.div`
  min-width: 290px;
  max-width: 420px;
  min-width: 420px;
  z-index: 5000;
  height: 190px;
  padding-bottom: 3rem;
  background: ${(props) => props.theme.white};
  color: ${(props) => props.theme.defaultFontColor};
  box-shadow: 0 0 55px 0 ${(props) => props.theme.boxShadow};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 20px;
  .header {
    height: 20px;
  }
  .step-content {
    text-align: left;
    height: auto;
    min-height: 45px !important;
    width: 380px;
  }
  .tour-buttons {
    position: absolute;
    bottom: 5px;
    height: 50px;
    display: flex;
    width: 90%;
    justify-content: space-evenly;
    button {
      margin: 10px;
    }
  }
  .tour-close-icon {
    position: absolute;
    right: 8px;
    top: 8px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    min-width: 290px;
    max-width: 420px;
    height: 225px;
    padding-bottom: 3rem;
    padding: 20px;
    .header {
      height: 30px;
    }
    .step-content {
      height: auto;
      min-height: 50px !important;
    }
    .tour-buttons {
      position: absolute;
      bottom: 10px;
      height: 50px;
      display: flex;
      width: 380px;
      justify-content: space-evenly;
      button {
        margin: 10px;
      }
    }
    .tour-close-icon {
      position: absolute;
      right: 8px;
      top: 8px;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    min-width: 550px;
    max-width: 550px;
    height: 300px;
    padding-bottom: 3rem;
    padding: 20px;
    .header {
      height: 30px;
    }
    .step-content {
      height: auto;
      min-height: 50px !important;
    }
    .tour-buttons {
      position: absolute;
      bottom: 25px;
      height: 50px;
      display: flex;
      width: 380px;
      justify-content: space-evenly;
      button {
        margin: 10px;
      }
    }
    .tour-close-icon {
      position: absolute;
      right: 15px;
      top: 15px;
    }
  }
`;

export const JoyRideToolTip = ({
  cypressId,
  id,
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
}) => {
  const nextButton = step?.customNextButton;
  const backButton = step?.customBackButton;
  return (
    <JoyRideToolTipStyle
      id={id}
      className=""
      data-cy={cypressId}
      {...tooltipProps}
    >
      {step.title && <div className="header heading60">{step.title}</div>}
      <div className="body-content body10">
        <div className="step-content">{step.content}</div>

        <div className="tour-close-icon">
          <IconButton
            enabled={true}
            id="icon-button"
            module={module}
            style={{ cursor: "pointer" }}
            props={closeProps}
          >
            <img data-cy="close-button" src={CloseIcon} alt="" />
          </IconButton>
        </div>
        <div className="tour-buttons">
          {index > 0 && !step?.customBackButton && !step?.noBackButton && (
            <div className="body10">
              <BloxButton
                className="buttons41"
                id="okay"
                text="BACK"
                module={step?.module}
                enabled={true}
                props={backProps}
                cypressId="okay"
              />
            </div>
          )}
          {/* {index === 0 && (
					<BloxButton
						className='buttons41'
						id='okay'
						text='SKIP'
						module={step?.module}
						enabled={true}
						props={closeProps}
						cypressId='okay'
					/>
				)} */}
          {!step?.customNextButton && (
            <BloxButton
              className="buttons41"
              id="okay"
              text={step?.locale?.next}
              module={step?.module}
              enabled={true}
              props={primaryProps}
              cypressId="tour-next"
            />
          )}
          {nextButton && step?.customNextButton}
          {backButton && step?.customBackButton}
          {!continuous && (
            <BloxButton
              className="buttons41"
              id="okay"
              text="CLOSE"
              module={step?.module}
              enabled={true}
              props={closeProps}
              cypressId="okay"
            />
          )}
        </div>
      </div>
    </JoyRideToolTipStyle>
  );
};
